import { useCallback, useRef } from 'react';
import type { DependencyList } from 'react';

type MaybePromise<T> = T | Promise<T>;

export function useSingletonCallback<T extends unknown[], R>(
  callback: (...args: T) => MaybePromise<R>,
  deps: DependencyList
): (...args: T) => Promise<R | undefined> {
  const inProgressRef = useRef(false);

  return useCallback(async (...args: T) => {
    if (inProgressRef.current) {
      return;
    }
    inProgressRef.current = true;
    try {
      return callback(...args);
    } finally {
      inProgressRef.current = false;
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
